import { GQLCouponFragment } from '@theprintbar/graphql';
import { getCurrencyValue } from '../../utils';

export const couponIsValid = (coupon: GQLCouponFragment): boolean => {
	if (!coupon || !coupon.code) return false;
	if (coupon.startDate && new Date(coupon.startDate) > new Date()) return false;
	if (coupon.endDate && new Date(coupon.endDate) < new Date()) return false;
	if (coupon.hasLimit && coupon.discountRemaining && getCurrencyValue(coupon.discountRemaining) <= 0) return false;
	if (coupon.maximumUses && (coupon.timesUsed || 0) >= coupon.maximumUses) return false;
	return true;
};
